// based on vc-align 2.4.3
import Align from './Align'
export default Align



// WEBPACK FOOTER //
// ./components/vc-align/index.js